// removed by extract-text-webpack-plugin
module.exports = {"category-select-modal":"category-select-modal","button-manage-categories":"button-manage-categories","categories-container":"categories-container","category-search":"category-search","categories-message":"categories-message","category-select-item":"category-select-item","category":"category","filled":"filled","unknown":"unknown","disabled":"disabled","category-name":"category-name"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/modals/component/category-select-modal/category-select-modal.style.sass
// module id = eN5m
// module chunks = 0